"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWarehousedDefinitionWithDayConfig = exports.testSingleNumberEffectiveDefinition = exports.getConstantSingleNumberEffectiveDefinition = exports.testEffectiveDefinition = exports.getConstantEffectiveDefinition = void 0;
var comparison_1 = require("./features/comparison");
var metricValue_1 = require("./features/metricValue");
var integration_1 = require("./features/window/integration");
var getters_1 = require("./features/threshold/getters");
var models_1 = require("./models");
var constantEffectiveDefinition = {
    schema: {
        measure: {
            type: 'number',
            name: metricValue_1.MEASURE_COLUMN_NAME,
        },
        timestamp: {
            type: 'datetime',
            name: metricValue_1.TIMESTAMP_COLUMN_NAME,
            dateGranularity: models_1.DateGranularity.DAY,
        },
        color: {
            type: 'string',
            name: 'color',
        },
        comparisonMeasure: {
            type: 'number',
            name: comparison_1.COMPARISON_MEASURE_COLUMN_NAME,
        },
        comparisonTimestamp: {
            type: 'datetime',
            name: comparison_1.COMPARISON_TIMESTAMP_COLUMN_NAME,
        },
    },
    features: {
        color: {
            column: 'color',
        },
        measure: { column: metricValue_1.MEASURE_COLUMN_NAME },
        timestamp: { column: metricValue_1.TIMESTAMP_COLUMN_NAME },
        threshold: {
            thresholds: [
                {
                    lines: [
                        {
                            measure: { column: comparison_1.COMPARISON_MEASURE_COLUMN_NAME },
                            timestamp: { column: comparison_1.COMPARISON_TIMESTAMP_COLUMN_NAME },
                        },
                    ],
                },
            ],
        },
    },
};
var getConstantEffectiveDefinition = function () {
    return constantEffectiveDefinition;
};
exports.getConstantEffectiveDefinition = getConstantEffectiveDefinition;
exports.testEffectiveDefinition = (0, exports.getConstantEffectiveDefinition)();
var constantSingleNumberEffectiveDefinition = {
    schema: {
        measure: {
            type: 'number',
            name: metricValue_1.MEASURE_COLUMN_NAME,
        },
        timestamp: {
            type: 'datetime',
            name: metricValue_1.TIMESTAMP_COLUMN_NAME,
            dateGranularity: models_1.DateGranularity.DAY,
            isSnapshotTimestamp: true,
            isTimeless: true,
        },
        color: {
            type: 'string',
            name: 'color',
        },
        comparisonMeasure: {
            type: 'number',
            name: comparison_1.COMPARISON_MEASURE_COLUMN_NAME,
        },
        comparisonTimestamp: {
            type: 'datetime',
            name: comparison_1.COMPARISON_TIMESTAMP_COLUMN_NAME,
        },
    },
    features: {
        color: {
            column: 'color',
        },
        measure: { column: metricValue_1.MEASURE_COLUMN_NAME },
        timestamp: { column: metricValue_1.TIMESTAMP_COLUMN_NAME },
        threshold: {
            thresholds: [
                {
                    lines: [
                        {
                            measure: { column: comparison_1.COMPARISON_MEASURE_COLUMN_NAME },
                            timestamp: { column: comparison_1.COMPARISON_TIMESTAMP_COLUMN_NAME },
                        },
                    ],
                },
            ],
        },
    },
};
var getConstantSingleNumberEffectiveDefinition = function () {
    return constantSingleNumberEffectiveDefinition;
};
exports.getConstantSingleNumberEffectiveDefinition = getConstantSingleNumberEffectiveDefinition;
exports.testSingleNumberEffectiveDefinition = (0, exports.getConstantSingleNumberEffectiveDefinition)();
/**
 * Defect 1450480. This function takes a definition and makes sure that the window and comparison are of day
 * granularity if the metric is warehoused
 *
 * @param definition the EffectiveDefinition
 * @returns The same definition with an altered window and/or comparison if the metric is warehoused and has
 * a mark based window and/or a mark based comparison
 */
var getWarehousedDefinitionWithDayConfig = function (definition) {
    var _a, _b, _c, _d;
    if ((0, metricValue_1.isTimelessWithWarehousingEnabled)(definition)) {
        var window = (0, integration_1.getFirstWindow)(definition);
        if (window && (0, integration_1.isLastNWindow)(window)) {
            // Since an unedited warehoused metric would have no date window, we want to remove the 100 Mark date window
            // instead of replacing it with a 90 Day window.
            if (((_b = (_a = definition.features.dateWindow) === null || _a === void 0 ? void 0 : _a.dateWindows) === null || _b === void 0 ? void 0 : _b.length) === 1) {
                var features = __assign({}, definition.features);
                delete features.dateWindow;
                definition = __assign(__assign({}, definition), { features: features });
            }
            else {
                definition = __assign(__assign({}, definition), { features: __assign(__assign({}, definition.features), { dateWindow: {
                            dateWindows: (_d = (_c = definition.features.dateWindow) === null || _c === void 0 ? void 0 : _c.dateWindows) === null || _d === void 0 ? void 0 : _d.slice(1),
                        } }) });
            }
        }
        var isMarkBasedComparison = !(0, getters_1.isDefaultLineStaticRefLine)(definition) && (0, comparison_1.getComparisonGranularity)(definition) === undefined;
        if (isMarkBasedComparison) {
            definition = (0, comparison_1.definitionWithComparison)(definition, (0, comparison_1.defaultComparisonForGranularity)(models_1.DateGranularity.DAY), true);
        }
    }
    return definition;
};
exports.getWarehousedDefinitionWithDayConfig = getWarehousedDefinitionWithDayConfig;
//# sourceMappingURL=utils.js.map